import { StyledRow as Row, WrapMdMarginBottom } from "App/global-style";

/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import styled from "styled-components";

export const StyledTileHeader = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledRow = styled(Row)`
  flex-grow: 1;
`;

export const StyledFlexRow = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
`;

export const IllustrationContainer = styled(WrapMdMarginBottom)`
  display: flex;
  justify-content: center;
`;
